// import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';

// As a plugin
import VuePrlx from 'vue-prlx'
Vue.use(VuePrlx);

// // As a directive (local)
// import { VuePrlxDirective } from 'vue-prlx'
// Vue.directive('prlx', VuePrlxDirective);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')


